(function(){
  if (window.__mjadeSwatchSelected) return;
  window.__mjadeSwatchSelected = true;

  var RAIL = '.product-block-options--swatch';
  var ITEM = '.product-block-options--swatch .product-block-options__item';
  var OFF  = 'product-block-options__item--unavailable';
  var BAR  = 'mj-sw-bar';

  // 스와치 상자 안쪽 맨 아래. 밖(-5px)에 그리면 부모의 margin-bottom:-12px 탓에
  // 상자 바깥이 되어 잘린다. 어두운 사진에서도 읽히게 위에 흰 실선을 얹는다.
  var CSS = 'position:absolute;left:0;right:0;bottom:0;height:1px;'
          + 'background:#5c5c5c;'
          + 'pointer-events:none;z-index:2;border-radius:0;';

  function clear(rail){
    var old = rail.querySelectorAll('.' + BAR);
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    var on = rail.querySelectorAll('.mj-sw-on');
    for (var k = 0; k < on.length; k++){
      on[k].classList.remove('mj-sw-on');
      on[k].removeAttribute('aria-current');
    }
  }

  function mark(it){
    if (!it || it.classList.contains(OFF)) return;
    var rail = it.closest(RAIL);
    if (!rail) return;
    clear(rail);
    // 테마가 스와치 묶음을 opacity .6 으로 흐려 둔다. 흐리면 검은 줄도 회색이 된다.
    var box = it.closest('.product-block-options') || rail;
    box.style.opacity = '1';
    if (!it.style.position) it.style.position = 'relative';
    var bar = document.createElement('span');
    bar.className = BAR;
    bar.setAttribute('aria-hidden', 'true');
    bar.style.cssText = CSS;
    it.appendChild(bar);
    it.classList.add('mj-sw-on');
    it.setAttribute('aria-current', 'true');
  }

  function fromEvent(e){
    var el = e.target;
    if (!el || el.nodeType !== 1 || !el.closest) return;
    mark(el.closest(ITEM));
  }
  document.addEventListener('click', fromEvent, true);
  document.addEventListener('pointerup', fromEvent, true);
  document.addEventListener('touchend', fromEvent, true);
  // 테마는 hover 로도 사진을 바꾼다. 표시도 같은 색을 가리켜야 한다.
  document.addEventListener('mouseover', fromEvent, true);
  /* * 2026-09-01 — 줄을 «밖에서도» 옮길 수 있게 창구를 연다.
     PC 의 좌우 화살표는 스와치를 건드리지 않고 사진만 바꾼다. 그래서
     사진은 아이보리인데 줄은 카멜에 남아 있었다 [2026-09-01 1484px 실측].
     접기(__mjRailCollapse)와 같은 방식이다 — 그리는 규칙은 여기 한 곳에만 둔다. */
  window.__mjSwatchMark = mark;

  var busy = false;
  function seed(){
    if (busy) return;
    busy = true;
    try {
      var rails = document.querySelectorAll(RAIL);
      for (var i = 0; i < rails.length; i++){
        if (rails[i].querySelector('.' + BAR)) continue;
        /* ★ 2026-09-01 — 목록에서 한 상품을 색깔별 카드로 쪼갠 뒤부터는
           «그 카드가 대표하는 색» 에 표시를 건다(--mj-on).
           전에는 늘 첫 스와치였다. 그래서 카멜 카드인데 1번 스와치 밑에
           줄이 그어져 «떠 있는 사진과 다른 색» 이 골라진 것처럼 보였다
           [2026-09-01 430px 실측 · 대표님 「이상한 줄」 지적].
           쪼개지 않은 카드에는 --mj-on 이 없으므로 예전 그대로 첫 스와치다. */
        mark(rails[i].querySelector(
               '.product-block-options__item--mj-on:not(.' + OFF + ')')
             || rails[i].querySelector(
               '.product-block-options__item:not(.' + OFF + ')'));
      }
    } finally { busy = false; }
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', seed);
  } else { seed(); }
  window.addEventListener('load', seed);
  // 지연 로딩으로 뒤늦게 그려지는 카드도 잡는다.
  if (window.MutationObserver){
    new MutationObserver(function(){
      clearTimeout(window.__mjSwT);
      window.__mjSwT = setTimeout(seed, 120);
    }).observe(document.documentElement, { childList:true, subtree:true });
  }
})();
